import { getSessionDetail, updateSessionLink, updateCoachNotes, cancelSession } from '../ajax.js';
import { renderSessionDetailPopup } from '../render.js';
import { visoStore } from '../store.js';
import { updateSessionButtons } from '../utilities.js';


export async function handleEventClick(info) {
	const sessionId = info.event.id;

	if (!sessionId || typeof wpcore === 'undefined') {
		return;
	}

	const session = await getSessionDetail(sessionId);
	if (!session) {
		wpcore.alert('error', wpcore.direct_t({ en: 'Failed to fetch session details', fr: 'Échec de la récupération des détails de la session' }));
		return;
	}

	renderSessionDetailPopup(session);
	updateSessionButtons(session);
	wpcore.showPopup('session-detail');
}


export function initSaveLinkHandler() {
	const saveLinkBtn = document.getElementById('save-link-btn');
	if (!saveLinkBtn) return;

	saveLinkBtn.addEventListener('click', async () => {
		const linkInput = document.getElementById('session_link');
		if (!linkInput) return;

		const link = linkInput.value.trim();
		const sessionData = visoStore.getCurrentSession();

		if (!sessionData || !sessionData.id) {
			return;
		}

		// Disable button while saving
		saveLinkBtn.disabled = true;
		saveLinkBtn.textContent = wpcore.direct_t({ en: 'Saving...', fr: 'Enregistrement...' });

		try {
			const result = await updateSessionLink(sessionData.id, link);
			saveLinkBtn.textContent = wpcore.direct_t({ en: 'Save', fr: 'Enregistrer' });
			saveLinkBtn.disabled = false;

			if (result.success) {
				wpcore.showAlert('success', wpcore.direct_t({ en: 'Success', fr: 'Succ\u00e8s' }), wpcore.direct_t({ en: 'Link saved successfully!', fr: 'Lien enregistr\u00e9 avec succ\u00e8s !' }));
			} else {
				wpcore.showAlert('error', wpcore.direct_t({ en: 'Error', fr: 'Erreur' }), result.message);
			}
		} catch {
			saveLinkBtn.textContent = wpcore.direct_t({ en: 'Save', fr: 'Enregistrer' });
			saveLinkBtn.disabled = false;
			wpcore.showAlert('error', wpcore.direct_t({ en: 'Error', fr: 'Erreur' }), wpcore.direct_t({ en: 'An error occurred. Please try again.', fr: 'Une erreur est survenue. Veuillez r\u00e9essayer.' }));
		}
	});
}


export function initSendNoteHandler() {
	const sendNoteBtn = document.getElementById('session-popup-send-note');
	if (!sendNoteBtn) return;

	sendNoteBtn.addEventListener('click', async () => {
		const notesTextarea = document.getElementById('coach_notes');
		if (!notesTextarea) return;

		const coachNotes = notesTextarea.value.trim();
		const sessionData = visoStore.getCurrentSession();

		if (!sessionData || !sessionData.id) {
			return;
		}

		// Disable button while saving
		sendNoteBtn.disabled = true;
		sendNoteBtn.textContent = wpcore.direct_t({ en: 'Sending...', fr: 'Envoi...' });

		try {
			const result = await updateCoachNotes(sessionData.id, coachNotes);
			sendNoteBtn.textContent = wpcore.direct_t({ en: 'Send Note', fr: 'Envoyer la note' });
			sendNoteBtn.disabled = false;

			if (result.success) {
				wpcore.showAlert('success', wpcore.direct_t({ en: 'Success', fr: 'Succès' }), wpcore.direct_t({ en: 'Note sent to student!', fr: 'Note envoyée à l\'étudiant !' }));
				// Hide send button and make textarea readonly after success
				sendNoteBtn.style.display = 'none';
				notesTextarea.readOnly = true;
			} else {
				wpcore.showAlert('error', wpcore.direct_t({ en: 'Error', fr: 'Erreur' }), result.message);
			}
		} catch {
			sendNoteBtn.textContent = wpcore.direct_t({ en: 'Send Note', fr: 'Envoyer la note' });
			sendNoteBtn.disabled = false;
			wpcore.showAlert('error', wpcore.direct_t({ en: 'Error', fr: 'Erreur' }), wpcore.direct_t({ en: 'An error occurred. Please try again.', fr: 'Une erreur est survenue. Veuillez r\u00e9essayer.' }));
		}
	});
}

export function initJoinSessionHandler() {
	const joinBtn = document.getElementById('session-popup-join');
	if (!joinBtn) return;

	joinBtn.addEventListener('click', () => {
		// Get link from input first, fallback to stored join_url
		const linkInput = document.getElementById('session_link');
		const inputValue = linkInput ? linkInput.value.trim() : '';
		const sessionData = visoStore.getCurrentSession();
		const joinUrl = inputValue || sessionData?.join_url;

		if (!joinUrl) {
			wpcore.showAlert('error', wpcore.direct_t({ en: 'Error', fr: 'Erreur' }), wpcore.direct_t({ en: 'No meeting link available.', fr: 'Aucun lien de r\u00e9union disponible.' }));
			return;
		}

		// Open join_url in new tab
		window.open(joinUrl, '_blank');
	});
}

export function initCardJoinHandler() {
	const listView = document.getElementById('list-view');
	if (!listView) return;

	listView.addEventListener('click', async (e) => {
		// Handle Join button
		const joinBtn = e.target.closest('[data-action="join"]');
		if (joinBtn) {
			if (joinBtn.disabled) return;
			const joinUrl = joinBtn.getAttribute('data-join-url');
			if (!joinUrl) {
				if (typeof wpcore !== 'undefined' && wpcore.showAlert) {
					wpcore.showAlert('error', wpcore.direct_t({ en: 'Error', fr: 'Erreur' }), wpcore.direct_t({ en: 'No meeting link available.', fr: 'Aucun lien de réunion disponible.' }));
				}
				return;
			}
			window.open(joinUrl, '_blank');
			return;
		}

		// Handle View detail + Send link → open session detail popup
		const actionBtn = e.target.closest('[data-action="view-detail"], [data-action="send-link"]');
		if (actionBtn) {
			const sessionId = actionBtn.getAttribute('data-session-id');
			if (!sessionId) return;

			const session = await getSessionDetail(sessionId);
			if (!session) return;

			renderSessionDetailPopup(session);
			updateSessionButtons(session);
			wpcore.showPopup('session-detail');
		}
	});
}


export function initCancelSession() {
	document.addEventListener('click', async (e) => {
		// Step 1: Open cancel confirmation popup
		const cancelBtn = e.target.closest('[data-action="cancel-session"]');
		if (cancelBtn) {
			let sessionId = cancelBtn.dataset.sessionId;
			if (!sessionId && visoStore.getCurrentSession()) {
				sessionId = visoStore.getCurrentSession().id;
			}

			if (!sessionId) {
				wpcore.showAlert('error', wpcore.direct_t({ en: 'Error', fr: 'Erreur' }), wpcore.direct_t({ en: 'Session ID not found.', fr: 'ID de session introuvable.' }));
				return;
			}

			// Populate cancel popup with session data
			const sessionIdInput = document.getElementById('cancel-session-id');
			if (sessionIdInput) sessionIdInput.value = sessionId;

			const avatarEl = document.getElementById('cancel-coach-avatar');
			const nameEl = document.getElementById('cancel-coach-name');
			const specialtyEl = document.getElementById('cancel-coach-specialty');
			const dateEl = document.getElementById('cancel-session-date');
			const timeEl = document.getElementById('cancel-session-time');

			if (avatarEl) avatarEl.src = cancelBtn.dataset.coachAvatar || '';
			if (nameEl) nameEl.textContent = cancelBtn.dataset.coachName || '';
			if (specialtyEl) specialtyEl.textContent = cancelBtn.dataset.coachSpecialty || '';
			if (dateEl) dateEl.textContent = cancelBtn.dataset.sessionDate || '';
			if (timeEl) timeEl.textContent = cancelBtn.dataset.sessionTime || '';

			if (typeof wpcore.showPopup === 'function') {
				wpcore.showPopup('cancel');
			}
			return;
		}

		// Step 2: Confirm cancellation from popup
		const confirmBtn = e.target.closest('[data-action="confirm-cancel"]');
		if (!confirmBtn) return;

		const sessionIdInput = document.getElementById('cancel-session-id');
		const sessionId = sessionIdInput ? sessionIdInput.value : '';
		if (!sessionId) return;

		confirmBtn.disabled = true;
		const originalText = confirmBtn.textContent;
		confirmBtn.textContent = wpcore.direct_t({ en: 'Canceling...', fr: 'Annulation...' });

		try {
			const result = await cancelSession(sessionId);
			confirmBtn.disabled = false;
			confirmBtn.textContent = originalText;

			if (result.success) {
				// Close cancel popup and show success popup
				wpcore.closePopup('cancel');
				if (typeof wpcore.showPopup === 'function' && document.getElementById('popup-cancel-success')) {
					wpcore.showPopup('cancel-success');
				} else {
					window.location.reload();
				}
			} else {
				wpcore.showAlert('error', wpcore.direct_t({ en: 'Error', fr: 'Erreur' }), result.message);
			}
		} catch {
			confirmBtn.disabled = false;
			confirmBtn.textContent = originalText;
			wpcore.showAlert('error', wpcore.direct_t({ en: 'Error', fr: 'Erreur' }), wpcore.direct_t({ en: 'An error occurred. Please try again.', fr: 'Une erreur est survenue. Veuillez réessayer.' }));
		}
	});
}
